<script>
    import axios from 'axios';
    import { useVuelidate } from '@vuelidate/core';
    import { required } from '@vuelidate/validators';

    export default {
        setup() {
            return { v$: useVuelidate() }
        },
        data() {
            return {
                loading: false,
                editedUser: {
                    id: '',
                    firstname: '',
                    insertion: '',
                    lastname: '',
                    username: '',
                    email: '',
                    roleName: '',
                    roleID: '',
                    active: true,
                    lastLoginAt: '',
                    organisationName: '',
                },
                roles: [],
            }
        },
        validations() {
            return {
                editedUser: {
                    firstname: { required },
                    lastname: { required },
                    roleID: { required },
                },
            }
        },
        props: {
            user: Object,
        },
        async created() {
            this.loading = true;
            await this.getUserRoles();
            this.editedUser = {
                ...this.user,
            };
            this.loading = false;
        },
        methods: {
            close() {
                this.$store.commit('closeModal');
            },
            async getUserRoles() {
                const response = await axios.get('/api/organisation/memberroles');
                this.roles = response.data;
            },
            async edit() {
                const result = await this.v$.$validate();
                if (result) {
                    await axios.put(`/api/organisation/employees/${this.user.id}/fullname`,
                    {
                        Firstname: this.editedUser.firstname,
                        Insertion: this.editedUser.insertion,
                        Lastname: this.editedUser.lastname,
                        Username: this.editedUser.username
                    });
                    await axios.put(`/api/organisation/employees/${this.user.id}/role`, { ID: this.editedUser.roleID });
                    this.close();
                    location.reload();
                }
            }
        }
    };
</script>

<template>
    <header class="modal-card-head">
        <p class="modal-card-title">{{ $store.getters.getUserManagementText('usermanagementModalTitleEdit') }}</p>
        <button class="delete" aria-label="close" @click="close"></button>
    </header>
    <section class="modal-card-body">
        <div class="notification is-danger" v-if="v$.$error">
            {{ $store.getters.getUserManagementText('usermanagementModalErrorAll') }}
        </div>
        <div class="form-error has-text-danger" v-if="v$.$error">
            {{ $store.getters.getUserManagementText('usermanagementModalErrorIndicator') }}
        </div>
        <div class="field">
            <label class="label" for="firstname"><span class="has-text-danger">*</span> {{ $store.getters.getUserManagementText('usermanagementModalLabelFirstname') }}</label>
            <div class="control">
                <input class="input" type="text" name="firstname" required v-model="editedUser.firstname">
            </div>
            <span v-if="v$.editedUser.firstname.$error" class="has-text-danger form-error">{{ $store.getters.getUserManagementText('usermanagementModalError') }}</span>
        </div>
        <div class="field">
            <label class="label" for="insertion">{{ $store.getters.getUserManagementText('usermanagementModalLabelInsertion') }}</label>
            <div class="control">
                <input class="input" type="text" name="insertion" required v-model="editedUser.insertion">
            </div>
        </div>
        <div class="field">
            <label class="label" for="lastname"><span class="has-text-danger">*</span> {{ $store.getters.getUserManagementText('usermanagementModalLabelLastname') }}</label>
            <div class="control">
                <input class="input" type="text" name="lastname" required v-model="editedUser.lastname">
            </div>
            <span v-if="v$.editedUser.lastname.$error" class="has-text-danger form-error">{{ $store.getters.getUserManagementText('usermanagementModalError') }}</span>
        </div>
        <div class="field">
            <label class="label" for="role"><span class="has-text-danger">*</span> {{ $store.getters.getUserManagementText('usermanagementModalLabelRole') }}</label>
            <div class="control">
                <div class="select">
                    <select name="role" required v-model="editedUser.roleID">
                        <option v-for="role in roles" :key="`role-${role.id}`" :value="role.id">{{ role.alias }}</option>
                    </select>
                </div>
            </div>
            <span v-if="v$.editedUser.roleID.$error" class="has-text-danger form-error">{{ $store.getters.getUserManagementText('usermanagementModalError') }}</span>
        </div>
    </section>
    <footer class="modal-card-foot is-justify-content-end">
        <button class="button is-primary is-outlined" @click="close">{{ $store.getters.getUserManagementText('usermanagementModalButtonCancel') }}</button>
        <button class="button is-primary" @click="edit">{{ $store.getters.getUserManagementText('usermanagementModalButtonSave') }}</button>
    </footer>
</template>
